var countries = require('@/lang/getCountryCode.json');

//通过IP返回国家代码
const getCountryCodeByIP=(getCountryCode,getCountryList)=>{
    var countriesKeyToval = getCountryListKV('alpha_2','alpha_3');  
    if(getCountryCode in countriesKeyToval){
        let currCountry = [];
        let countrycode = countriesKeyToval[getCountryCode];
        // if(['HKG'].includes(countrycode))countrycode = 'CHN';//HKG默认转成CHN

        if(countrycode in getCountryList) return countrycode;
        return null;
    }else{
        return null;
    }
}

function getCountryListKV(key,value){
    const checkArr = ['name', 'traditionalName', 'chineseName', 'alpha_2', 'alpha_3', 'numericCode']
    if (!checkArr.includes(key) || !checkArr.includes(value)) return 'invalid key or value'
  
    let obj = {};
    countries.forEach(item=>{
      if(item[key])obj[item[key]] = item[value];
    })
    return obj
}

module.exports = getCountryCodeByIP;


// WEBPACK FOOTER //
// ./src/assets/js/getCountryCodeByIP.js